<template>
  <b-card>
    <form method="post" action="" autocomplete="off">
      <div slot="header">
        <strong>{{title}}</strong>
      </div>
      <div class="row">
        <div class="col-sm-4">
          <strong>{{$t('BASICDATA')}}</strong>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4">
          <b-form-fieldset v-bind:label="$t('USERNAME')">
            <inputvalidation :formerror="formError" name="username"><b-form-input type="text" v-model="formData.username" v-bind:placeholder="$t('USERNAME')"></b-form-input></inputvalidation>
          </b-form-fieldset>
        </div>
        <div class="col-sm-4">
          <b-form-fieldset v-bind:label="$t('PASSWORD')">
            <inputvalidation :formerror="formError" name="password"><b-form-input type="password" v-model="formData.password" v-bind:placeholder="$t('PASSWORD')"></b-form-input></inputvalidation>
          </b-form-fieldset>
        </div>
        <div class="col-sm-4">
          <b-form-fieldset v-bind:label="$t('USEREMAIL')">
            <inputvalidation :formerror="formError" name="userEmail"><b-form-input type="email" v-model="formData.userEmail" v-bind:placeholder="$t('USEREMAIL')"></b-form-input></inputvalidation>
          </b-form-fieldset>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4" v-if="!newuser">
          <b-form-fieldset v-bind:label="$t('COMPANY')">
            <inputvalidation :formerror="formError" name="companyId"><b-form-select :options="userCompanies.root" v-model="formData.companyId" value-field="companyId" text-field="companyName"></b-form-select></inputvalidation>
          </b-form-fieldset>
        </div>
        <div class="col-sm-4" v-if="!newuser">
          <b-form-fieldset v-bind:label="$t('USERGROUP')">
            <inputvalidation :formerror="formError" name="groupId"><b-form-select :options="aclGroups.root" v-model="formData.groupId" value-field="groupId" text-field="groupName"></b-form-select></inputvalidation>
          </b-form-fieldset>
        </div>
        <div class="col-sm-4" :class="(newuser) ? 'col-sm-12' : ''">
          <b-form-fieldset v-bind:label="$t('STATUS')">
            <inputvalidation :formerror="formError" name="status"><b-form-select :options="status" v-model="formData.status"></b-form-select></inputvalidation>
          </b-form-fieldset>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4">
          <strong>{{$t('ADDITIONALDATA')}}</strong>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <b-form-fieldset v-bind:label="$t('NAME')">
            <inputvalidation :formerror="formError" name="name"><b-form-input type="text" v-model="formData.name" v-bind:placeholder="$t('NAME')"></b-form-input></inputvalidation>
          </b-form-fieldset>
        </div>
        <div class="col-sm-6">
          <b-form-fieldset v-bind:label="$t('SURNAME')">
            <inputvalidation :formerror="formError" name="surname"><b-form-input type="text" v-model="formData.surname" v-bind:placeholder="$t('SURNAME')"></b-form-input></inputvalidation>
          </b-form-fieldset>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-3">
          <b-form-fieldset v-bind:label="$t('ADDRESS')">
            <inputvalidation :formerror="formError" name="address"><b-form-input type="text" v-model="formData.address" v-bind:placeholder="$t('ADDRESS')"></b-form-input></inputvalidation>
          </b-form-fieldset>
        </div>
        <div class="col-sm-3">
          <b-form-fieldset v-bind:label="$t('CITY')">
            <inputvalidation :formerror="formError" name="city"><b-form-input type="text" v-model="formData.city" v-bind:placeholder="$t('CITY')"></b-form-input></inputvalidation>
          </b-form-fieldset>
        </div>
        <div class="col-sm-3">
          <b-form-fieldset v-bind:label="$t('POSTALCODE')">
            <inputvalidation :formerror="formError" name="postalCode"><b-form-input type="text" v-model="formData.postalCode" v-bind:placeholder="$t('POSTALCODE')"></b-form-input></inputvalidation>
          </b-form-fieldset>
        </div>
        <div class="col-sm-3">
          <b-form-fieldset v-bind:label="$t('COUNTRY')">
            <inputvalidation :formerror="formError" name="country"><b-form-input type="text" v-model="formData.country" v-bind:placeholder="$t('COUNTRY')"></b-form-input></inputvalidation>
          </b-form-fieldset>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4">
          <b-form-fieldset v-bind:label="$t('PHONE')">
            <inputvalidation :formerror="formError" name="phone"><b-form-input type="text" v-model="formData.phone" v-bind:placeholder="$t('PHONE')"></b-form-input></inputvalidation>
          </b-form-fieldset>
        </div>
        <div class="col-sm-4">
          <b-form-fieldset v-bind:label="$t('OIBNUM')">
            <inputvalidation :formerror="formError" name="oibNum"><b-form-input type="text" v-model="formData.oibNum" v-bind:placeholder="$t('OIBNUM')"></b-form-input></inputvalidation>
          </b-form-fieldset>
        </div>
        <div class="col-sm-4">
          <b-form-fieldset v-bind:label="$t('MBASEUSERID')">
            <inputvalidation :formerror="formError" name="mBaseUserId"><b-form-input type="text" v-model="formData.mBaseUserId" v-bind:placeholder="$t('MBASEUSERID')"></b-form-input></inputvalidation>
          </b-form-fieldset>
        </div>
      </div>
      <div slot="footer">
        <p class="bg-danger" v-if="formError.error && typeof formError.notice == 'string'">{{formError.notice}}</p>
        <b-button type="submit" size="sm" variant="primary" v-on:click.prevent="saveRow(formData)"><icon icon="dot-circle"></icon> {{$t('SUBMIT')}}</b-button>
      </div>
    </form>
  </b-card>
</template>

<script>

import AclGroupsApi from '@/api/admin/AclGroups'
import UserCompaniesApi from '@/api/admin/UserCompanies'

export default {
  name: 'UsersForm',
  props: ['title', 'formData', 'formError', 'status', 'newuser'],
  data()
  {
    return {
      aclGroups: {},
      userCompanies: {},
      pagination:
      {
        query: '',
        currentPage: 1,
        limit: 5000,
        searchTimeout: false
      }
    }
  },
  created: function()
  {
    var me = this;
    me.getAclGroups();
    me.getUserCompanies();
  },
  methods:
  {
    getAclGroups: function()
    {
      var me = this;
      AclGroupsApi.selectRow({start: 0, limit: 5000}, function(data)
      {
        if(data.error && data.error == true)
        {
          me.$notify.notice(data);
          return;
        }
        me.aclGroups = data;
      });
    },
    getUserCompanies: function()
    {
      var me = this;
      UserCompaniesApi.selectRow(me.getParams, function(data)
      {
        if(data.error && data.error == true)
        {
          me.$notify.notice(data);
          return;
        }
        me.userCompanies = data;
      });
    },
    saveRow(formData)
    {
      var me = this;
      me.$emit('saveRow', formData);
    }
  },
  watch:
  {
    'pagination.currentPage': function(val)
    {
      var me = this;
      me.getData();
    },
    'pagination.query': function(val)
    {
      var me = this;

      if(me.pagination.searchTimeout != false) clearTimeout(me.pagination.searchTimeout);

      me.pagination.searchTimeout = setTimeout(function()
      {
        me.getData();
        me.pagination.searchTimeout = false;
      }, 300);
    }
  },
  computed:
  {
    getParams: function()
    {
      var me = this;
      var data = Object.assign({}, me.pagination, {});
      data.start = (data.currentPage-1)*data.limit;
      return data;
    }
  }
}
</script>
